import dayRoutes from './day.routes';

import daySaveController from './controllers/day.save.controller';
import dayFormController from './controllers/day.form.controller';
import dayListController from './controllers/day.list.controller';
import daySelectController from './controllers/day.select.controller';
import daySingleSelectController from './controllers/day.single.select.controller';

import dayListComponent from './components/day.list.component';
import dayFormComponent from './components/day.form.component';
import daySaveComponent from './components/day.save.component';
import daySelectComponent from './components/day.select.component';
import daySingleSelectComponent from './components/day.single.select.component';

import dayService from './services/day.service';

let daysModule = angular.module('spabooker.day', [ 'spabooker.base', 'spabooker.event' ])
  .config(dayRoutes)

  .controller('daySaveController', daySaveController)
  .controller('dayFormController', dayFormController)
  .controller('dayListController', dayListController)
  .controller('daySelectController', daySelectController)
  .controller('daySingleSelectController', daySingleSelectController)

  .component('dayList', dayListComponent)
  .component('dayForm', dayFormComponent)
  .component('daySave', daySaveComponent)
  .component('daySelect', daySelectComponent)
  .component('daySingleSelect', daySingleSelectComponent)

  .factory('dayService', dayService)
;

export default daysModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/days/index.js